(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["prenco-product-ar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('prenco-product-ar')) {
    customElements.define('prenco-product-ar', class extends HTMLElement {
      connectedCallback() {
        this.start = () => this.initialize();
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, { once: true });
        else this.initialize();
      }
      initialize() {
        if (this.controller || !this.isConnected) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const launch = this.querySelector('[data-shopify-xr]');
        const help = this.querySelector('[data-ar-help]');
        const dialog = this.querySelector('dialog');
        const input = this.querySelector('[data-ar-link]');
        const status = this.querySelector('[data-ar-status]');
        const url = new URL(this.dataset.productUrl, location.origin);
        const variant = new URL(location.href).searchParams.get('variant');
        if (variant) url.searchParams.set('variant', variant);
        if (window.Shopify?.theme?.role !== 'main') url.searchParams.set('preview_theme_id', this.dataset.themeId);
        input.value = url.href;
        help.addEventListener('click', () => { status.textContent = ''; dialog.showModal(); }, options);
        this.querySelector('[data-ar-close]').addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        }, options);
        this.querySelector('[data-ar-copy]').addEventListener('click', async () => {
          try { await navigator.clipboard.writeText(input.value); status.textContent = status.dataset.copied; }
          catch { input.focus(); input.select(); status.textContent = status.dataset.copyFailed; }
        }, options);
        const sync = () => { help.hidden = !launch.hasAttribute('data-shopify-xr-hidden'); };
        this.observer = new MutationObserver(sync);
        this.observer.observe(launch, { attributes: true, attributeFilter: ['data-shopify-xr-hidden'] });
        const setup = () => {
          if (!this.isConnected || !window.ShopifyXR) return;
          if (!this.modelsAdded) {
            window.ShopifyXR.addModels(JSON.parse(this.querySelector('[data-ar-models]').textContent));
            this.modelsAdded = true;
          }
          window.ShopifyXR.setupXRElements();
          sync();
        };
        document.addEventListener('shopify_xr_initialized', setup, options);
        if (window.ShopifyXR) setup();
        else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'shopify-xr', version: '1.0', onLoad: error => { if (!error) setup(); } }]);
        sync();
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.start);
        this.controller?.abort(); this.controller = null;
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
